import { Check, X } from 'lucide-react';
import { cn } from '@/lib/cn';

export type StationState = 'passed' | 'failed' | 'pending';

/**
 * Una fila de avance: la comparten las estaciones del KYC y las de la apertura de cuenta, para que
 * el criterio de color no se desincronice. Un `failed` va en ÁMBAR y nunca en rojo — no es el
 * veredicto, es un paso reintentable —, y el estado va en texto para lectores de pantalla.
 */
export function StationRow({
    label,
    state,
    pendingLabel = 'Pendiente',
    detail,
}: {
    label: string;
    state: StationState;
    /** Cómo se nombra lo que todavía no cerró — el KYC dice "Pendiente"; la cuenta, "En curso". */
    pendingLabel?: string;
    detail?: string;
}) {
    const passed = state === 'passed';
    const failed = state === 'failed';

    return (
        <li className="mb-2 flex items-start gap-3 text-[12.5px]">
            <span
                className={cn(
                    'mt-0.5 flex size-5 flex-none items-center justify-center rounded-full transition-colors',
                    passed && 'bg-success-soft text-success',
                    failed && 'bg-warning-soft text-warning',
                    !passed && !failed && 'bg-muted',
                )}
            >
                {passed && <Check className="size-3" strokeWidth={3} aria-hidden />}
                {failed && <X className="size-3" strokeWidth={3} aria-hidden />}
                {!passed && !failed && (
                    <span className="size-1.5 rounded-full bg-muted-foreground" />
                )}
            </span>
            <span>
                <span
                    className={cn(
                        'block font-medium',
                        !passed && !failed && 'text-muted-foreground',
                    )}
                >
                    {label}
                    {/* Va PEGADO a la etiqueta: después del detalle se leía "Coincidencia del
                        rostro, no coincide…, No pasó". */}
                    <span className="sr-only">
                        {' '}
                        — {passed ? 'Completado' : failed ? 'No pasó' : pendingLabel}
                    </span>
                </span>
                {detail && (
                    <span
                        className={cn('block', failed ? 'text-warning' : 'text-muted-foreground')}
                    >
                        {detail}
                    </span>
                )}
            </span>
        </li>
    );
}
